import React, { useContext, useEffect, useState, useRef } from 'react'
import PageTitle from '../../../Components/PageTitle'
import { ConfigContext } from '../../../Context/ConfigContext'
import { GlobalLimitChanger, SubmitBtn } from '../../../Components/InputElements'
import { NoRecords, TableRows } from '../../../Components/Shimmer'
import axios from 'axios'
import Swal from 'sweetalert2'
import { NavLink } from 'react-router-dom'

const ProductList = () => {
    const { primaryColor, apiHeaderJson, apiURL } = useContext(ConfigContext)
    const headersJson = apiHeaderJson;

    const [data, setData] = useState([])
    const [next, setNext] = useState(false)
    const [prev, setPrev] = useState(false)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalRecords, setTotalRecords] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [loading, setLoading] = useState(true)

    // Filter states
    const [keyword, setKeyword] = useState('')
    const [productPublishStatus, setProductPublishStatus] = useState('')
    const [productStockStatus, setProductStockStatus] = useState('')
    const [productTrendingStatus, setProductTrendingStatus] = useState('')

    const getData = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${apiURL}Masters/GetProducts`, {
                headers: headersJson,
                params: {
                    keyword,
                    product_publish_status: productPublishStatus,
                    product_stock_status: productStockStatus,
                    product_trending_status: productTrendingStatus,
                    page,
                    limit
                }
            })
            const { success, data, page: currentPage, next, prev, total_pages, total_records } = response.data

            if (success) {
                setData(data)
                setPage(currentPage)
                setNext(next)
                setPrev(prev)
                setTotalPages(total_pages)
                setTotalRecords(total_records)
            }
        } catch (error) {
            console.log("error", error)
            Swal.fire('Error!', 'Failed to fetch products', 'error')
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async (product_id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        })
        if (result.isConfirmed) {
            setLoading(true)
            try {
                const body = { product_id: product_id }
                const response = await axios.post(`${apiURL}Masters/DeleteProduct`, body, { headers: headersJson })
                const { message, success } = response.data

                Swal.fire('Deleted!', message, success ? 'success' : 'error')

                if (success) {
                    getData()
                }
            } catch (error) {
                console.error(error)
                Swal.fire('Error!', 'Something went wrong', 'error')
            } finally {
                setLoading(false)
            }
        }
    }

    const handlePrev = () => {
        if (prev) {
            setPage(prev => prev - 1)
        }
    }

    const handleNext = () => {
        if (next) {
            setPage(prev => prev + 1)
        }
    }

    const handlePageChange = (e) => {
        setPage(parseInt(e.target.value, 10))
    }

    const resetFilters = () => {
        setKeyword('')
        setProductPublishStatus('')
        setProductStockStatus('')
        setProductTrendingStatus('')
        setPage(1)
    }

    const getStatusBadge = (status) => {
        return status === 1 ?
            <span className="badge bg-success">Yes</span> :
            <span className="badge bg-danger">No</span>
    }
    const getSignatureBadge = (status) => {
        return status === 1 ?
            <span className="badge bg-success">Signature</span> :
            <span className="badge bg-danger">Not Signature</span>
    }

    const getStockBadge = (status) => {
        return status === 1 ?
            <span className="badge bg-success">In Stock</span> :
            <span className="badge bg-danger">Out of Stock</span>
    }

    const getTrendingBadge = (status) => {
        return status === 1 ?
            <span className="badge bg-warning">Trending</span> :
            <span className="badge bg-secondary">Normal</span>
    }

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setPage(1)
            getData()
        }, 500)

        return () => clearTimeout(delayDebounce)
    }, [keyword, productPublishStatus, productStockStatus, productTrendingStatus])

    useEffect(() => {
        getData()
    }, [limit, page])

    const handleViewImage = (img) => {
        Swal.fire({
            imageUrl: img,
            imageWidth: 200,
            imageHeight: 200,
            imageAlt: 'Custom uploaded image',
        });
    }

    return (
        <>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <PageTitle title="Product List" primary="Products" />
                        <div className="row">
                            <div className="card p-0">
                                <div className="card-header d-flex flex-wrap justify-content-between algin-items-center" style={{ backgroundColor: primaryColor }}>
                                    <h4 className="card-title mb-0 text-white">
                                        Products List
                                    </h4>
                                    <NavLink type='button' to="/Masters/ManageProducts" className="btn btn-sm btn-light"><i className='ri-play-list-add-line' /></NavLink>
                                </div>

                                <div className="card-body border-bottom">
                                    <div className="row g-3">
                                        <div className="col-md-3">
                                            <select
                                                className="form-select"
                                                value={productPublishStatus}
                                                onChange={(e) => setProductPublishStatus(e.target.value)}
                                            >
                                                <option value="">All Status</option>
                                                <option value="1">Published</option>
                                                <option value="0">Not Published</option>
                                            </select>
                                        </div>
                                        {/* <div className="col-md-3">
                                            <select
                                                className="form-select"
                                                value={productStockStatus}
                                                onChange={(e) => setProductStockStatus(e.target.value)}
                                            >
                                                <option value="">All Stock</option>
                                                <option value="1">In Stock</option>
                                                <option value="0">Out of Stock</option>
                                            </select>
                                        </div> */}
                                        <div className="col-md-3">
                                            <select
                                                className="form-select"
                                                value={productTrendingStatus}
                                                onChange={(e) => setProductTrendingStatus(e.target.value)}
                                            >
                                                <option value="">All Trending</option>
                                                <option value="1">Trending</option>
                                                <option value="0">Not Trending</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3 d-flex align-items-end">
                                            <button
                                                className="btn btn-soft-primary waves-effect waves-light material-shadow-none"
                                                onClick={getData}
                                            >
                                                Apply
                                            </button>
                                            <button
                                                className="btn btn-soft-warning waves-effect waves-light material-shadow-none ms-3"
                                                onClick={resetFilters}
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4" />
                                        <div className=" col-md-4" />
                                        <div className=" col-md-4 mt-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search products..."
                                                name='keyword'
                                                value={keyword}
                                                onChange={(e) => setKeyword(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="table-responsive table-card">
                                        <table className="table table-bordered table-striped table-nowrap table-hover mb-0">
                                            {loading ? (
                                                <TableRows rows="10" colspan="7" />
                                            ) : (
                                                <>
                                                    <thead className="table-light text-center">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Image</th>
                                                            <th>Product Title</th>
                                                            <th>Publish Status</th>
                                                            <th>Signature Status</th>
                                                            <th>Trending Status</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data.length > 0 ? (
                                                            data.map((row, index) => (
                                                                <tr key={row.product_id} className="text-center">
                                                                    <td>{row.product_id}</td>
                                                                    <td>
                                                                        {row.product_image_url ? (
                                                                            <img
                                                                                src={row.product_image_url}
                                                                                alt={row.product_title}
                                                                                className="img-thumbnail"
                                                                                style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                                                            />
                                                                        ) : (
                                                                            <div
                                                                                className="img-thumbnail d-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    width: '80px',
                                                                                    height: '80px',
                                                                                    backgroundColor: '#f8f9fa',
                                                                                    color: '#6c757d'
                                                                                }}
                                                                            >
                                                                                <i className="ri-image-line" style={{ fontSize: '24px' }}></i>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-start">
                                                                        <div>
                                                                            <strong>{row.product_title}</strong>
                                                                        </div>
                                                                        {row.product_specification && (
                                                                            <small className="text-muted">
                                                                                {row.product_specification.replace(/<[^>]*>/g, '').substring(0, 50)}...
                                                                            </small>
                                                                        )}
                                                                        {row.product_signature_image_url && <div style={{ cursor: 'pointer' }}>
                                                                            <span className='text-primary' onClick={() => handleViewImage(row.product_signature_image_url)}>Signature Image</span>
                                                                        </div>}
                                                                    </td>
                                                                    <td>{getStatusBadge(row.product_publish_status)}</td>
                                                                    <td>{getSignatureBadge(row.product_signature_status)}</td>
                                                                    <td>{getTrendingBadge(row.product_trending_status)}</td>
                                                                    <td>
                                                                        {/* New Manage Features button */}
                                                                        <NavLink
                                                                            className="btn btn-sm btn-soft-info me-2"
                                                                            title="Manage Features"
                                                                            to={`/Masters/ManageProductFeatures/${row.product_id}`}
                                                                        >
                                                                            <i className='ri-list-settings-line'></i>
                                                                        </NavLink>
                                                                        <NavLink
                                                                            className="btn btn-sm btn-soft-info me-2"
                                                                            title="Manage Gallery"
                                                                            to={`/Masters/ManageProductGallery/${row.product_id}`}
                                                                        >
                                                                            <i className='ri-image-2-line'></i>
                                                                        </NavLink>
                                                                        <NavLink
                                                                            className="btn btn-sm btn-soft-primary me-2"
                                                                            title="Edit Product"
                                                                            to={`/Masters/ManageProducts/${row.product_id}`}
                                                                        >
                                                                            <i className='ri-pencil-line'></i>
                                                                        </NavLink>
                                                                        <button
                                                                            className="btn btn-sm btn-soft-danger"
                                                                            onClick={() => handleDelete(row.product_id)}
                                                                            title="Delete Product"
                                                                        >
                                                                            <i className='ri-delete-bin-line'></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={7}>
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                    <tfoot className='table-light'>
                                                        <tr>
                                                            <th colSpan={7}>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <button
                                                                        disabled={!prev || loading}
                                                                        type="button"
                                                                        onClick={handlePrev}
                                                                        className={`btn btn-warning btn-label waves-effect waves-light`}
                                                                    >
                                                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous
                                                                    </button>

                                                                    <div className='d-flex align-items-center gap-3'>
                                                                        <small>
                                                                            Total Records: {totalRecords} |
                                                                            Total Pages: {totalPages} |
                                                                            Current Page: {page}
                                                                        </small>

                                                                        <select
                                                                            className="form-select"
                                                                            value={page}
                                                                            onChange={handlePageChange}
                                                                            style={{ width: 'auto' }}
                                                                        >
                                                                            {Array.from({ length: totalPages }, (_, i) => (
                                                                                <option key={i + 1} value={i + 1}>
                                                                                    {i + 1}
                                                                                </option>
                                                                            ))}
                                                                        </select>

                                                                        <GlobalLimitChanger
                                                                            placeholder="Set limit:"
                                                                            name="globalLimit"
                                                                            value={limit}
                                                                            onChange={setLimit}
                                                                            showAllValue={totalRecords}
                                                                        />
                                                                    </div>

                                                                    <button
                                                                        disabled={!next || loading}
                                                                        type="button"
                                                                        onClick={handleNext}
                                                                        className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                                    >
                                                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next
                                                                    </button>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </tfoot>
                                                </>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductList